import axios from '@/plugins/axios'
import { useAppStore } from '@/stores/app'
import type IDataResponse from '@/interfaces/api-resources/DataResponse'

export default {
  baseUrl() {
    const appStore = useAppStore()

    return `${appStore.daraApiBaseUrl}/organisation-settings/`
  },

  update(organisationSettingsId: number, formData: object) {
    return axios.put<
      IDataResponse<App.Http.Resources.ApiV3.OrganisationSettingResource>,
      IDataResponse<App.Http.Resources.ApiV3.OrganisationSettingResource>
    >(this.baseUrl() + organisationSettingsId, formData)
      .then(({ data }) => data)
  },
}
